import { ArrowBack } from '@mui/icons-material';
import { Divider, Grid, IconButton, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FC } from 'react';
import { PageTitle } from './PageTitle';
import { useHistory } from 'react-router';

export interface IPageWithBackTitleProps {
  backText: string;
  backUrl: string;
  title: string;
  additionalHeaderContent?: JSX.Element;
  subTitle?: string | JSX.Element;
  showDivider?: boolean;
  isExternalLink?: boolean;
}

export const PageTitleWithBack: FC<IPageWithBackTitleProps> = ({
  backText = 'Back',
  showDivider = true,
  backUrl,
  title,
  additionalHeaderContent,
  subTitle,
  isExternalLink = false
}) => {
  const classes = useStyles({ marginBottom: false });
  const history = useHistory();
  const params = new URLSearchParams(window.location.search);
  const redirectToUrl = params.get('redirect');

  const navigateToUrl = (url: string) => {
    window.location.href = url;
  };

  return (
    <>
      <Grid container className={classes.titleWrapper}>
        {backUrl && (
          <Grid item className={classes.iconButton}>
            <IconButton
              title={backText}
              sx={{
                paddingLeft: 0
              }}
              onClick={() =>
                isExternalLink
                  ? navigateToUrl(backUrl)
                  : history.push(redirectToUrl ? redirectToUrl : backUrl)
              }
            >
              <ArrowBack
                sx={{
                  fontSize: { xs: 18, sm: 24 }
                }}
              />
            </IconButton>
          </Grid>
        )}
        <Grid item xs={12} className={classes.pageTitleWrapper}>
          <PageTitle
            showDivider={false}
            title={title}
            additionalHeaderContent={additionalHeaderContent}
            subTitle={subTitle}
            justifyContent="flex-start"
            flexDirection="row"
          />
        </Grid>
      </Grid>
      {showDivider && title && <Divider className={classes.divider} />}
    </>
  );
};

const useStyles = makeStyles<Theme, { marginBottom: boolean }>(theme => ({
  divider: {
    marginBottom: theme.spacing(1)
  },
  pageTitleWrapper: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  titleWrapper: {
    display: 'flex',
    flexWrap: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      alignItems: 'flex-start'
    }
  },
  subTitle: {
    display: 'block',
    color: '#000',
    marginTop: 5
  },
  iconButton: {
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      top: theme.spacing(-0.25)
    }
  }
}));
